import jump from "./jump";

function getNewContent(url: string,data: {}) {
    let fetchOptions: RequestInit = {}

    fetchOptions.headers = new Headers({
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': "application/json",
        'Content-Type': "application/json"
    }); 
    
    fetchOptions.method = 'POST';
    fetchOptions.body = JSON.stringify(data);

    return fetch(url,fetchOptions).then((response) => {
        if(response.ok) {
            return response.json();
        }
        return Promise.reject(response);
    })
}

export default function applyFilters(form: HTMLFormElement, get: boolean = true) {
    if('action' in form) {
        let url = form.action;
        url = url.replace(/\/?$/, '/');

        let formdata = new FormData(form);
        let entries = formdata.entries();
        let data = Object.fromEntries(entries);

        for(let key in data) {
            if(typeof data[key] == 'string') {
                if(data[key].length > 0) {
                    url += data[key]+'/';
                } else {
                    url += 'all-'+key+'/';
                }
            }
        }

        if(get) {
            if(
                'ajax' in form.dataset && form.dataset.ajax != undefined
                && 'id' in form.dataset && form.dataset.id != undefined
            ) {     
                let queryblock = form.parentElement?.querySelector('.wp-block-taxonomy-filter-results');
                queryblock?.classList.add('filter-results-loading');  
                return getNewContent(form.dataset.ajax,{
                    ...data, 
                    post: form.action, 
                    id: form.dataset.id
                }).then((json: any) => {
                    
                    if(
                        'content' in json && json.content != undefined
                        && queryblock != null
                    ) {
                        const parser = new DOMParser();
                        const html = parser.parseFromString(json.content,'text/html');
                        const content = html.body.children[0];
                        content.classList.add('filter-results-loading');
                        queryblock.replaceWith(content);
                        window.history.pushState(data,'',url);
                        setTimeout(() => {
                            content.classList.remove('filter-results-loading');
                        },50);
                        return json.content;
                    } else {
                        return Promise.reject();
                    }
                }).catch(() => {
                    queryblock?.classList.remove('filter-results-loading');  
                    console.error('Unable to load ajax content.  Reloading page...');
                    window.location.assign(url);
                });
            } else {
                console.error('No ajax variables.  Reloading page...');
                window.location.assign(url);
            }
        } else {
            window.history.pushState(data,'',url);
            return Promise.resolve();
        }
    } else {
        const params = new URLSearchParams(window.location.search);

        let data = new FormData(form);

        for(let [key,value] of data.entries()) {
            if(typeof value == 'string') {
                params.set(key,value);
            }
        }

        window.location.search = params.toString();
    }

    return Promise.reject();
}